"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var keautils_1 = require("keautils");
/**
 * Create a filter matrix from a filter row. Uses filter joins and inversions for filling all matrix cells based on the given filter vector
 * @see invertFilter is used on columns equal to the given row and @see joinFilter on all others.
 * On columns equals to the current row, an idempotent function is used
 * @param givenRow The given row
 * @param vector The vector of filters used as a basis for generating all other filters
 * @param lists All items from the list, used as input for the joined filters
 */
exports.createMatrixFromRow = function (vector, givenRow) { return function (rowItems) {
    /*
    U			E			S			C
U   _   		UE   		UC 	  		UD
E   i(UE) 		_			j(UE,US)	j(UE,UC)
S	i(US)		j(US,UE)	_			j(US, UC)
C	i(UC)		j(UC,UE)	j(UC,US)	_

    */
    var keys = Object.keys(vector);
    var ret = {};
    var idem = function (x) { return x; };
    try {
        for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
            var row = keys_1_1.value;
            if (row == givenRow) {
                //The given row is passed as is
                ret[row] = vector;
            }
            else {
                ret[row] = {};
                try {
                    for (var keys_2 = __values(keys), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
                        var column = keys_2_1.value;
                        ret[row][column] =
                            //Si la fila y columna es igual, idempotencia
                            row == column ? idem :
                                //Si la columna == a la fila dada, inversionm
                                column == givenRow ? invertFilter(vector[row]) :
                                    //Union de los filtros de la fila, con el de la columna actual
                                    joinFilter(vector[row], vector[column])(rowItems);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (keys_2_1 && !keys_2_1.done && (_a = keys_2.return)) _a.call(keys_2);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_b = keys_1.return)) _b.call(keys_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return ret;
    var e_2, _b, e_1, _a;
}; };
/**Apply a filter matrix */
exports.applyFilterMatrix = function (matrix) { return function (lists) { return function (values) {
    var matrixKeys = Object.keys(matrix);
    //Apply a single cell filter to an input element
    function applyCellFilter(row, column, rowInput) {
        var columnKey = values[column];
        var func = matrix[row][column];
        return func(rowInput, columnKey);
    }
    //Apply a full row of filters to an input element
    function applyRowFilter(row, input) {
        return matrixKeys.reduce(function (input, column) { return applyCellFilter(row, column, input); }, input);
    }
    var ret = {};
    try {
        for (var matrixKeys_1 = __values(matrixKeys), matrixKeys_1_1 = matrixKeys_1.next(); !matrixKeys_1_1.done; matrixKeys_1_1 = matrixKeys_1.next()) {
            var inputRow = matrixKeys_1_1.value;
            ret[inputRow] = applyRowFilter(inputRow, lists[inputRow]);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (matrixKeys_1_1 && !matrixKeys_1_1.done && (_a = matrixKeys_1.return)) _a.call(matrixKeys_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return ret;
    var e_3, _a;
}; }; };
/**
 * Invert a filter matrix function in the form of (list, value) => filter onto the form of (value, list) => filter.
 * Usefull for creating filters that depend exclusively on its matrix counterpart
 */
function invertFilter(cell) {
    return function (list, value) {
        if (value === undefined)
            return list;
        //Un de TValueKey encaja con uno de TListKey si el filtro cell para ([valor], elemento) devuelve mas de 0 elementos
        var testFunction = function (item) { return cell([value], item).length > 0; };
        return list.filter(testFunction);
    };
}
exports.invertFilter = invertFilter;
/**
 * Return a filter that returns all items from the list when the value is undefined
 * @param filter An input filter
 */
function onUndefinedAll(filter) {
    return function (list, value) {
        if (value === undefined)
            return list;
        else
            return filter(list, value);
    };
}
exports.onUndefinedAll = onUndefinedAll;
/**
 * Filter a list by a given many to many relationship
 * @param relations All relations between the list items and the possible values
 * @param list The list to filter
 * @param idValue The key of the filter value
 * @param listKeySelector Select a list key
 * @param relationListSelector Select the list key for a many to many relationship item
 * @param relationValueSelector Select the value key of a many to many relationship item
 */
function manyToManyFilter(relations, list, idValue, listKeySelector, relationListSelector, relationValueSelector) {
    return keautils_1.pipe(relations, function (x) { return x.map(function (y) { return ({ idList: relationListSelector(y), idValue: relationValueSelector(y) }); }); }, function (x) { return x.filter(function (y) { return y.idValue == idValue; }); }, function (x) { return x.map(function (y) { return y.idList; }); }, function (x) { return keautils_1.intersectKeys(list, x, listKeySelector); });
}
exports.manyToManyFilter = manyToManyFilter;
/**
 * Get a filter in the form of (list: TOut[], value: TIn) given two filters on the form: (list: TMid[], value: TOut) and (list: TMid[], value: TIn)
 * @param filterMidByOut A filter in the form (list: TMid[], value: TOut)
 * @param filterMidByIn A filter in the form (list: TMid[], value: TIn)
 */
function joinFilter(filterMidByOut, filterMidByIn) {
    return function (allMid) { return function (list, value) {
        var filteredMid = filterMidByIn(allMid, value);
        return intersectArrayByFilter(list, filteredMid, function (a, b) { return filterMidByOut(a, b); });
    }; };
}
exports.joinFilter = joinFilter;
/**
 * Return the intersection of two lists given a filter that define the relationship between these lists.
 * This is equal to get a list of TList, given a list of TKey and a filter of (TKey[], TList)
 * @param items
 * @param keys
 * @param filter
 */
function intersectArrayByFilter(items, keys, filter) {
    return items.filter(function (item) { return filter(keys, item).length > 0; });
}
exports.intersectArrayByFilter = intersectArrayByFilter;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/filtermatrix/index.js
// module id = 2164
// module chunks = 0